import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import AudioContainer from '../components/audio-container.vue';
import generateId from '@/utils/generateId.js';

export default {
  components: {
    AudioContainer: AudioContainer
  },

  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false
    },
    fileUrl: {
      type: String,
      required: true
    },
    uploadRequest: {
      type: Function,
      required: true
    },
    validate: {
      type: Function,
      default: function _default() {}
    }
  },

  data: function data() {
    return {
      uploading: false
    };
  },


  computed: {
    dialog: function dialog() {
      var _this = this;

      return {
        visible: this.visible,
        title: this.$t('playTurbo.custom.resourceUploader.audioUploadTitle'),
        appendToBody: true,
        width: '420px',
        customClass: 'custom-uploader-dialog',
        beforeClose: function beforeClose(done) {
          if (_this.beforeClose()) {
            done();
            _this.close();
          }
        }
      };
    }
  },

  methods: {
    open: function open() {
      this.$emit('update:visible', true);
    },
    close: function close() {
      this.$emit('update:visible', false);
    },
    handleClose: function handleClose() {
      this.$emit('update:visible', false);
    },
    handleSubmit: function handleSubmit() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var valid;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.validate();

              case 2:
                valid = _context.sent;

                if (valid) _this2.uploadFile();

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    beforeClose: function beforeClose() {
      if (this.uploading) {
        this.$message.warning(this.$t('playTurbo.custom.resourceUploader.uploadingTips'));
        return false;
      }
      return true;
    },
    updateUploading: function updateUploading(val) {
      this.uploading = val;
    },
    uploadFile: function uploadFile() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var fileName, res, file;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.updateUploading(true);
                _context2.prev = 1;
                fileName = 'temp_' + generateId() + '.mp3';
                // 素材自研中消费只支持mp3,因此上传都以mp3为后缀

                _context2.next = 5;
                return _this3.uploadRequest({
                  file_base64: _this3.fileUrl.split(',')[1],
                  filename: fileName,
                  rename: fileName
                });

              case 5:
                res = _context2.sent;


                if (res.data && res.data.code === 0) {
                  file = res.data.data;

                  _this3.$emit('upload-success', {
                    file: file
                  });
                  _this3.close();
                }
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](1);

                console.log(_context2.t0);

              case 12:
                _this3.updateUploading(false);

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[1, 9]]);
      }))();
    }
  }
};